<template>
  <nav class="api-nav">
    <div class="api-nav__prev">
      <RouterLink v-if="prevRoute" :to="prevRoute.to">
        <div class="api-nav__direct">
          <SvgIcon icon="chevron-left" />Предыдущая статья
        </div>
        <div class="api-nav__title">
          {{ prevRoute.title }}
        </div>
      </RouterLink>
    </div>
    <div class="api-nav__next">
      <RouterLink v-if="nextRoute" :to="nextRoute.to">
        <div class="api-nav__direct">
          Следующая статья <SvgIcon icon="chevron-right" />
        </div>
        <div class="api-nav__title">
          {{ nextRoute.title }}
        </div>
      </RouterLink>
    </div>
  </nav>
</template>

<script lang="ts" src="./ApiDocsNav.ts"></script>

<style scoped lang="scss" src="./ApiDocsNav.scss"></style>
